// Copyright (c) 2022 Enabler Interactive Pty Ltd

import React, { Component } from 'react'
import { Form, FormGroup, Row, Col, FormControl, Button, ControlLabel, Clearfix, Alert } from 'react-bootstrap'
import config from '../config/config.json'

export class ForgotPassword extends Component {
    constructor() {
        super()

        this.state = {
            formAlertType: 'danger',
            formAlertDisplay: 'none',
            formAlertText: ''
        }

        this.handleOnSubmit = this.handleOnSubmit.bind(this)
        this.resetPasswordByApi = this.resetPasswordByApi.bind(this)
    }

    formAlertUpdate(type, display, text) {
        this.setState({
            formAlertType: type,
            formAlertDisplay: display,
            formAlertText: text
        })
    }

    handleOnSubmit(e) {
        e.preventDefault()

        let formData = {
            email: this.emailInput.value
        }

        if (!formData.email) {
            alert("Please enter an email")
        } else {
            this.resetPasswordByApi(formData)
        }
    }

    resetPasswordByApi(data) {
        fetch(config[this.props.env] + config.api.reset_password.endpoint, {
            method: config.api.reset_password.type,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                email: data.email
            })
        }).then((response) => response.json())
            .then((responseJson) => {
                if (responseJson.message === 'Reset email sent') {
                    this.formAlertUpdate('success', 'block', 'An email has been sent to you with a reset token.')
                    setTimeout(() => { this.props.router.push('/login') }, 1500)
                } else if (responseJson.errors === 'Invalid email') {
                    this.formAlertUpdate('danger', 'block', 'Looks like this email account does not exist.')
                } else if (responseJson.error) {
                    this.formAlertUpdate('danger', 'block', '')
                }
            })
            .catch((error) => {
                console.error(error)
            })
    }

    render() {
        let containerClass = "forgot-password-container page-container"

        return (

            <div className={containerClass}>
                <div className="banner">
                    <Col smOffset={2} sm={8}>
                        <h2 className="title">Forgot Password</h2>
                    </Col>
                    <Clearfix />
                </div>
                <Row>
                    <Col sm={12}>
                        <Alert bsStyle={this.state.formAlertType} style={{ display: this.state.formAlertDisplay }} onDismiss={this.handleAlertDismiss}>
                            <h3>{this.state.formAlertType === 'danger' ? "An error occurred" : "Success"}</h3>
                            <p className="alert-text">{this.state.formAlertText}</p>
                        </Alert>
                    </Col>
                </Row>
                <Form horizontal className="forgot-password-form">
                    <FormGroup controlId="formHorizontalEmail">
                        <Col componentClass={ControlLabel} sm={4}>
                            Email
                        </Col>
                        <Col sm={5}>
                            <FormControl type="email" placeholder="Email" inputRef={ref => { this.emailInput = ref }} />
                            <FormControl.Feedback />
                        </Col>
                    </FormGroup>

                    <hr className="invisible post-form" />
                    <FormGroup>
                        <Col smOffset={4} sm={5}>
                            <Button type="submit" bsStyle="primary" onClick={this.handleOnSubmit} >
                                Reset Password
                            </Button>
                        </Col>
                        <Col sm={2}>
                        </Col>
                    </FormGroup>
                </Form>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/containers/forgotPassword.js